import Label from '@/components/Label/Label';
import Tooltip from '@/components/Tooltip/Tooltip';

export default {
  name: 'LabelList',
  components: {
    Label,
    Tooltip
  },
  props: ['names', 'max'],
  data() {
    return {};
  },
  computed: {
    items() {
      return this.max ? this.max : 3;
    },
    visible() {
      return this.names.slice(0, this.max);
    },
    hidden() {
      return this.names
        .splice(this.max, this.names.length - this.max)
        .join(', ');
    },
    reserve() {
      return this.names.length - this.max;
    }
  },
  mounted() {},
  methods: {}
};
